<template>
  <div id="home">
    <div v-if="form_loading" class="loading_div">
      <i class="el-icon-loading" style="font-size: 30px;color: #ffffff;margin-bottom: 20px;"></i>
      <div style="font-size: 14px;color: #ffffff;">Please wait — this may take 1–2 minutes to generate. Do not close the window.</div>
    </div>
    <div class="div">
      <div class="title">
        Create Review Request
      </div>
      <div class="form">
        <div class="divt">
          Name*
          <el-input class="margin-top-switch name" placeholder="Jone Doe" v-model="ai_object.user_name"/>
        </div>

        <div class="divt">
          Assistants*
          <el-button class="margin-top-switch" style="width:100px;" size="mini" type="info" @click="select_show" round>Choice</el-button>
          <div class="margin-top-switch">
            <el-tag
              style="margin-left:10px;margin-top:10px;"
              v-for="(tag,index) in tags"
              :key="index"
              closable
              :type="tag.type"
              @close="closeTag(index)">
              {{tag.name}}
            </el-tag>
          </div>
        </div>

        <div class="divt">
          Comments
          <el-input class="margin-top-switch comments"
            placeholder="The patient visited the practice for implant treatment. Dr. James examined his teeth and gums and replaced the implants. The patient was satisfied with the results."
            type="textarea"
            :autosize="{ minRows: 6, maxRows: 10}"
             v-model="ai_object.staff_comment"
            resize="none"/>
        </div>

        <div style="display: flex;align-items: center;justify-content: center;">
          <span class="btn" style="margin-right: 10px;" @click="save">Create</span>
        </div>
      </div>
    </div>
    <select-staffs ref="selectStaffsModel" @ok="selectedEmployee"></select-staffs>
  </div>
</template>
<script>
  import Vue from 'vue';
  import { getActionApi,postActionApi } from '@/network/manageApi';
  import moment from 'moment/moment';
  import SelectStaffs from './aiBusiness/SelectStaffs'
  export default {
    name: 'CreateAiBusinessPromoter',
    components: {
      SelectStaffs
    },
    data() {
      return {
        tags: [],
        ai_object: {user_name: "", staff_comment: ""},
        form_loading: false
      }
    },
    computed: {

    },
    mounted() {

    },
    created(){
    },
    methods:{
      select_show() {
        this.$refs.selectStaffsModel.init()
      },
      selectedEmployee(list) {
        const map = this.tags.reduce((acc, item) => {
          acc[item.staff_uuid] = item;
          return acc;
        }, {});
        for(let item of list) {
          if(!map[item.review_employee_uuid]) {
            let obj = {name: item.employee_name, staff_uuid: item.review_employee_uuid}
            this.tags.push(obj);
          }
        }
      },
      closeTag(index) {
        this.tags.splice(index, 1);
      },
      moment,
      save() {
        if(!this.ai_object.user_name) {
          this.$message({
            message: 'Please enter name.',
            type: 'warning'
          });
          return;
        }
        if(this.tags.length == 0) {
          this.$message({
            message: 'Please add an assistant.',
            type: 'warning'
          });
          return;
        }
        if(!this.ai_object.staff_comment) {
          this.$message({
            message: 'Please fill in the comments.',
            type: 'warning'
          });
          return;
        }
        const staff_list = this.tags.map(item => item.staff_uuid);
        this.ai_object.staff_uuid_list = staff_list
        this.form_loading = true
        postActionApi("/review/business-promoter/ai-generate/init", this.ai_object).then((res) => {
          if(res.code == 201 || res.code == 200) {
            this.$message.success({message: "Save Success"});
            this.$router.push({path:'/aiBusinessPromoter/detail/' + res.data.review_generator_uuid})
          }
        }).catch((err) => {
          this.$message.error({message: err.response.data.details.data.message});
        }).finally((res) => {
          this.form_loading = false
        })
      }
    }
  }
</script>

<style scoped>
  body{overflow-x: hidden;}
  *{font-size:16px;font-size:inherit;box-sizing: border-box;}
  #home{background-color:#F8F9FA;padding:20px;display: grid;gap: 20px;}
  .div{background-color: #ffffff;padding: 30px;display: grid;gap: 20px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);border-radius: 16px;}
  .title{color:#2D3648;font-size: 20px;font-weight: bold;display: flex;justify-content: space-between;align-items: center;}
  .label{display: flex;align-items: center;justify-content: center;}
  .label .no{background-color: #FED7D7;color: #822727;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .label .yes{background-color: #b3edff;color: #0075cb;width: 28px;height: 20px;font-size: 12px;display: flex;align-items: center;justify-content: center;border-radius: 6px;margin-right: 5px;}
  .pager{display: flex;justify-content: center;}
  .btn{height:40px;width:86px;cursor: pointer;background-color: #5856D6;color:#ffffff;border-radius: 6px;font-size: 14px;display: flex;align-items: center;justify-content: center;}
  .form{display: flex;flex-direction: column;}
  .form .flex{display: grid;grid-template-columns:1fr 1fr;gap: 20px;padding-bottom: 0;}
  .form .divt{display: flex;flex-direction: column;color:#2D3748;font-weight: bold;padding-bottom:20px;}
  .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
  .margin-top-switch {margin-top: 10px;width: 500px;}

  .comments {width: 50%;}
  @media (max-width: 768px) {
    .title{flex-direction: column;}
    .div{padding:20px 5px;}
    .form .divt input{border-radius: 6px;border:1px solid #E2E8F0;height:40px;padding:0 20px;margin-top:10px;}
    .margin-top-switch {margin-top: 10px;width: 90%;}
    .comments {width: 98%;}
    .name {width: 98%;}
  }
  @media screen and (min-width: 769px) and (max-width: 1024px) {

  }
  .font-size-16 {font-size: 20px;}


  .loading_div {position: fixed;z-index:99999;width: 100vw;height: 100vh;top: 0;left: 0;display:flex;align-items: center;justify-content: center;background-color: rgba(0, 0, 0, 0.7);flex-direction: column;}
</style>
